module.exports = __webpack_public_path__ + "img/upstairs2.fd49ee95.jpg";